module.exports = __webpack_public_path__ + "static/media/pulse_logo.ea33f20b.png";